import { commonText } from './index';

export const transactionsTable = {
  header: 'All Transactions',
  export: 'Export Transactions',
  id: 'ID',
  status: 'Status',
  amount: 'Amount',
  email: 'Customer email',
  liability: 'Liability Shift',
  date: 'Date',
  actions: 'Actions',
};

export const sendReceipt = {
  cancel: commonText.cancel,

  sendReceipt: 'Send Receipt',
  send: 'Send',
  deliveryTo: 'Delivery to',
};
export const cancelPayment = {
  cancel: commonText.cancel,

  title: 'Cancel Payment',
  message:
    'Cancelled payments can take 5-10 days to be released from the customer account.',
  cancelling: 'Cancelling',
  amount: transactionsTable.amount,
  paymentMethod: 'Payment method',
  reason: 'Reason',
  selectReason: 'Select a reason',
  addMore: 'Add more details about this refund',
};
export const refundPayment = {
  cancel: commonText.cancel,

  title: 'Refund',
  header: 'Refund Payment',
  message: "Refunds take 5-10 days to appear on a customer's statement.",
  refunding: 'Refunding',
  amount: transactionsTable.amount,
  paymentMethod: 'Payment method',
  reason: 'Reason',
  selectReason: 'Select a reason',
  addMore: 'Add more details about this refund',
  errors: {
    amount: {
      max: (amount) => `Refund amount cannot be greater than €${amount || 0}`,
      required: 'Refund amount is required',
    },
    reason_option: {
      required: 'Reason is required',
    },
  },
};
export const capturePayment = {
  cancel: commonText.cancel,

  title: 'Capture',
  header: 'Capture Payment',
  message: (currency, amount) =>
    `Authorized Amount ${currency}${amount || '0.00'} on`,
  capturing: 'Capturing',
  amount: 'Capture Amount',
  addMore: 'Add more details about this capture',
  errors: {
    amount: {
      required: 'Amount is required',
    },
  },
  requireAdjustment:
    'This amount will require the transaction to be adjusted before capture',
  success: {
    adjust:
      'Your adjustment request has been sent to the provider. It may take sometime to result in. You will later have to come back to finally capture this transaction.',
    capture:
      'Your capture request has been sent to the provider. It may take sometime to result in. The status of the transaction will be updated accordingly.',
    captureAdyen: 'You have successfully requested an adjustment to the authorised amount.  Once approved you must Capture the payment in full.'
  },
};
export const transactionSummary = {
  payment: 'Payment',
  date: 'Date',
  customer_name: 'Customer Name',
  paymentMethod: 'Payment Method',
  fraudScore: 'Fraud Score',
  capturing: 'Capturing',
  adjusting: 'Adjusting',
};

export const transactionDetails = {
  header1: 'Transaction',
  goBack: 'Return to Transaction Report',

  details: {
    header: 'Transaction Details',
    id: 'ID',
    created_at: 'Created At',
    merchantRef: 'Merchant Reference',
    fraudScore: 'Fraud Score',
    amount: transactionsTable.amount,
    status: transactionsTable.status,
    net: 'Net Balance',
    psp: 'PSP Reference',
    company: 'Company',
    orderId: 'Order ID',
    cardId: 'Card ID',
    statement: 'Statement Descriptor',
    failure: 'Failure Reason',
    last: 'Last Authenticated',
    liability: transactionsTable.liability,
  },

  customerDetails: {
    header: 'Customer Details',
    customer_name: 'Customer Name',
    email: 'Email',
    country: 'Phone Country',
    phone: 'Phone Number',
    ref: 'Reference',
    card_holder: 'Cardholder Name',
    paymentMethod: 'Payment Method',
    summary: 'Card Summary',
    expiry: 'Card Expiry',
    postal: 'Postal Code',
  },

  feeStructure: {
    header: 'Fee Structure',
    amount: transactionsTable.amount,
    txtpay: 'TxtPay Fee',
    rebate: 'TxtPay Fee Rebate',
    processing: 'Processing Fee',
    schemeFee: 'Interchange/Scheme Fees',
    net: 'Net Balance',
    schemeFeeType: 'Interchange/Scheme Fee Type',
  },

  eventAndLogs: {
    header: 'Event & Logs'
  },
  chargeback: {
    title: 'Chargeback Fees',
  },
  actions: {
    title: 'Actions',
    name: 'Action',
    initiated_by: 'Initiated By',
    target: 'Transaction Id',
    status: transactionsTable.status,
    created_at: transactionsTable.date,
  },
  payouts: {
    title: 'Payouts',
    id: 'Payout Id',
    status: transactionsTable.status,
    company: 'Company',
    transactions: 'Transactions',
    gross: 'Gross Value',
    net: 'Net Value',
    estArrival: 'Est Arrival',
    refundAmt: 'Refund Amt',
    transferAmt: 'Transfer Amt',
  },
};
export const rowActions = {
  view: 'View Transaction Details',
  viewDetails: 'View Details',
  cancelPayment: 'Cancel Payment',
  capturePayment: 'Capture Payment',
  refund: 'Refund',
  sendReceipt: 'Send Receipt',
};
